import React from 'react';
import { css } from '@linaria/core';
import { Alert, Link } from '@livecommerce/design-system';
import { useUser } from 'contexts/UserContext.jsx';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import startCase from 'lodash/startCase';

const alertStyle = css`
  width: calc(100% - 16px);
  height: 56px;
  margin: 8px;
  border-radius: 8px;
  grid-column: 1 / 3;
  grid-row: 1 / 2;
`;

const textContainerStyle = css`
  width: 100%;
`;

const descriptionStyle = css`
  width: 100%;
`;

const titleStyle = css`
  text-align: center;
  width: 100%;
`;

const SuspensionAlert = ({ suspension, currentOrganization }) => {
  const { t } = useLocalization();
  const { userData } = useUser();
  const isClientAdmin = userData?.roles?.includes('admin');
  const variant = 'danger';
  const href = isClientAdmin ? `/admin/${currentOrganization.clientId}/billing` : 'mailto:support@bambuser.com';

  if (!suspension) {
    return null;
  }

  const { name } = suspension;

  return (
    <Alert
      dataTestId="suspensionNotificationBanner"
      title={
        <>
          {t('suspensionAlert.prefix', {}, 'Functionality related to')}{' '}
          <strong>{startCase(name)}</strong>{' '}
          {t('suspensionAlert.usageSuffix', {}, 'has been suspended due to usage limits.')}{' '}
          {isClientAdmin ? (
            t('suspensionAlert.adminSuffix', {
              billingLink: (
                <Link variant="linkBold" href={href}>
                  {t('suspensionAlert.billing', {}, 'billing page')}
                </Link>
              ),
            }, 'Please go to the {billingLink} to resolve this issue.')
          ) : (
            t('suspensionAlert.contactAdmin', {}, 'Please contact your client administrator to resolve this issue.')
          )}
        </>
      }
      variant={variant}
      className={alertStyle}
      textContainerProps={{ className: textContainerStyle }}
      titleProps={{ className: titleStyle }}
      descriptionProps={{ className: descriptionStyle }}
    />
  );
};

export default SuspensionAlert;
